"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseStyle_1 = require("./style/BaseStyle");
exports.BaseStyle = BaseStyle_1.BaseStyle;
const CheckHeaderStyle_1 = require("./style/CheckHeaderStyle");
exports.CheckHeaderStyle = CheckHeaderStyle_1.CheckHeaderStyle;
const MultilineTextHeaderStyle_1 = require("./style/MultilineTextHeaderStyle");
exports.MultilineTextHeaderStyle = MultilineTextHeaderStyle_1.MultilineTextHeaderStyle;
const SortHeaderStyle_1 = require("./style/SortHeaderStyle");
exports.SortHeaderStyle = SortHeaderStyle_1.SortHeaderStyle;
const Style_1 = require("./style/Style");
exports.Style = Style_1.Style;
function of(headerStyle, StyleClass) {
    if (headerStyle) {
        if (headerStyle instanceof Style_1.Style) {
            return headerStyle;
        }
        else if (typeof headerStyle === "function") {
            return of(headerStyle(), StyleClass);
        }
        return new StyleClass(headerStyle);
    }
    else {
        return StyleClass.DEFAULT;
    }
}
exports.of = of;
